import React from 'react'
import {Line} from 'react-chartjs-2'
import PropTypes from 'prop-types'
import { labelsFormatter } from 'utils/formatters'
import { colors } from 'utils/redux/config/colors'

const TinyLineChart = ({ abbr, history, weeklyHistory, mode, filter, weekly, ...props }) => {

	const data = weekly ? weeklyHistory.data : history.data

	const mainData = data
		.filter(rate => rate.to_crypto_currency_id === props.currency)
		.map(rate => ({
			label: labelsFormatter(rate.date, filter),
			price: parseFloat(rate.conversion_value)
		}))

	const colorEbony = '#282844'
	const colorCornFlower = '#3180ff'
	const mainColor = (mode === 'monetary')
		? colorEbony
		: ( abbr ? colors[abbr].color : colorCornFlower)

	const chartConfig = {
		data: {
			labels: mainData.map(rate => rate.label),
			datasets: [
				{
					label: 'Курс',
					backgroundColor: 'transparent',
					borderColor: mainColor,
					data: mainData.map(rate => rate.price)
				}
			]
		},
		options: {
			elements: { point: { radius: 0 } },
			legend: {
				display: false
			},
			scales: {
				xAxes: [{
					display: false,
					gridLines: {
						display: false
					}
				}],
				yAxes: [{
					display: false,
					gridLines: {
						display: false
					}
				}]
			}
		}
	}

	return <div>
		<Line data={chartConfig.data} options={chartConfig.options} />
	</div>
}

TinyLineChart.propTypes = {
	abbr: PropTypes.string,
	history: PropTypes.shape({
		data: PropTypes.arrayOf(PropTypes.shape({
			id: PropTypes.number,
			to_currency_id: PropTypes.number,
			conversion_value: PropTypes.string,
			inverse_conversion_value: PropTypes.string,
			name: PropTypes.string,
			abbreviature: PropTypes.string,
			flag: PropTypes.string,
			quantity: PropTypes.number,
			date: PropTypes.string
		})),
		isFetching: PropTypes.bool
	}),
	mode: PropTypes.string,
	filter: PropTypes.string,
	weekly: PropTypes.bool
}

export default TinyLineChart
